export const options = {
  maintainAspectRatio: false,

  scales: {},
  plugins: {
    datalabels: {
      display: false,
    },
    legend: {
      // display: false,
      position: "top",
    },
    title: {
      display: false,
      text: "Fraction per Detection Accuracy",
    },
  },
};
